import {Yii} from "libraries/interfaces/Yii";

import {Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges} from '@angular/core';
import {ISummary} from './ISummary';
import {ILabels} from "../../interfaces/ILabels";
import {LabelService} from "../../service/label/label.service";
import {faTimes, IconDefinition} from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'search-summary',
    template: `
        <card>
            <div class="card-header-content">
                {{ title || label.title }}
                <div class="ctn ctn-right">
                    <div class="btn-right">
                        <btnForm class="e2e-button-modifySearch" styleType="actionDo"
                                 (click)="onModifySearch.emit(true)">
                            {{ label.modifySearch }}
                        </btnForm>
                    </div>
                </div>
            </div>
            <div class="card-body-content">

                <mat-chip-list *ngIf="chips && chips.length > 0" [(ngModel)]="chips">
                    <mat-chip *ngFor="let chip of chips"
                              [removable]="isRemovable && !chip.isRequired"
                              (removed)="remove(chip)">
                        <ng-container [ngSwitch]="chip.field">
                            <ng-container *ngSwitchCase="'qualityCheck'">
                                <span class="cursor-help" [innerHTML]="chip | getLabel:'showCount'"></span>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                <span [innerHTML]="chip | getLabel"></span>
                            </ng-container>
                        </ng-container>
                        <fa-icon *ngIf="isRemovable && !chip.isRequired" matChipRemove [icon]="iconTimes"></fa-icon>
                    </mat-chip>
                </mat-chip-list>

                <ng-container *ngIf="!chips || !chips.length">
                    {{ label.noFilter }}
                </ng-container>
            </div>
        </card>
    `,
    styleUrls: [
        '../../../styles/angular-material/chip-list.scss'
    ],
    styles: [`
        .card-body-content {
            padding: 0.75rem;
        }
        
        .cursor-help {
            cursor: help;
        }

        :host ::ng-deep .ui-chips-input-token {
            display: none;
        }

        :host ::ng-deep .ui-chips > ul.ui-inputtext {
            cursor: auto;
        }

        :host ::ng-deep .ui-state-default.ui-corner-all {
            border: 0px solid transparent;
            padding-left: 0px;
        }

        :host ::ng-deep .ui-chips-token.ui-state-highlight.ui-corner-all:first-of-type {
            margin-left: 0;
        }

        :host ::ng-deep .ui-chips-token.ui-state-highlight.ui-corner-all {
            padding-right: 30px;
        }
    `]
})

export class SearchSummaryComponent implements OnInit, OnChanges {

    @Input()
    public fields: ISummary[];
    @Input()
    public title: string;
    @Input()
    public isRemovable: boolean = true;

    @Output()
    public readonly onModifySearch: EventEmitter<boolean> = new EventEmitter();

    @Output()
    public readonly onRemove: EventEmitter<ISummary[]> = new EventEmitter();
    public label: ILabels = {
        title: Yii.t('wui-shared-js', 'Résumé de la recherche'),
        modifySearch: Yii.t('wui-shared-js', 'Modifier la recherche'),
        noFilter: Yii.t('wui-shared-js', 'Aucun critère de recherche'),
    };

    public chips: ISummary[];
    public iconTimes: IconDefinition = faTimes;

    public ngOnInit(): void {
        this.initChips();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.fields.currentValue !== changes.fields.previousValue) {
            this.initChips();
        }
    }

    public initChips(): void {
        this.chips = this.fields;
    }

    public remove(field: ISummary): void {
        const filtered: ISummary[] = this.fields.filter((item: ISummary) => item.field === field.field);

        this.onRemove.emit(filtered);
    }
}
